import styled from 'styled-components';

type HasXY = {
  x?: number | null;
  y?: number | null;
};

type WrapperProps = {
  height: number;
  left: number;
  top: number;
  width: number;
};

const Wrapper = styled.div.attrs<WrapperProps>((props) => ({
  style: {
    height: `${props.height}px`,
    left: `${props.left}px`,
    top: `${props.top}px`,
    width: `${props.width}px`,
  },
}))<WrapperProps>`
  background: rgba(52, 143, 235, 0.4);
  border: 2px solid blue;
  pointer-events: none;
  position: fixed;
  z-index: 11;
`;

const BoxSelect = ({
  boxSelectStart,
  boxSelectCurrent,
}: {
  boxSelectStart: HasXY;
  boxSelectCurrent: HasXY;
}) => {
  if (
    !boxSelectStart.x ||
    !boxSelectStart.y ||
    !boxSelectCurrent.x ||
    !boxSelectCurrent.y
  )
    return null;
  const left = Math.min(boxSelectStart.x, boxSelectCurrent.x);
  const top = Math.min(boxSelectStart.y, boxSelectCurrent.y);
  const width = Math.abs(boxSelectStart.x - boxSelectCurrent.x);
  const height = Math.abs(boxSelectStart.y - boxSelectCurrent.y);
  return <Wrapper height={height} left={left} top={top} width={width} />;
};

export default BoxSelect;
